import { CalendarDays, MapPin } from "lucide-react";
import { Card, Section } from "../Layout";
import { useI18n } from "../i18n";

function TimelineItem({ time, title, desc }) {
  return (
    <div className="flex gap-4">
      <div className="w-20 shrink-0 text-xs tracking-[0.22em] uppercase text-theme-text-faint pt-1">
        {time}
      </div>
      <div className="flex-1 rounded-3xl border border-theme-border bg-theme-surface px-5 py-4">
        <div className="flex items-center justify-between gap-3">
          <p className="font-serif text-lg">{title}</p>
          <span className="h-2 w-2 rounded-full bg-theme-border" />
        </div>
        {desc && <p className="mt-2 text-sm text-theme-text-muted">{desc}</p>}
      </div>
    </div>
  );
}

function InfoPill({ icon: Icon, label }) {
  return (
    <div className="inline-flex items-center gap-2 rounded-full border border-theme-border bg-theme-surface px-4 py-2 text-sm text-theme-text-muted">
      <Icon className="h-4 w-4" />
      {label}
    </div>
  );
}

export default function Details() {
  const { t, get } = useI18n();
  const timeline = get("details.timeline") || [];

  return (
    <Section
      id="details"
      eyebrow={t("details.eyebrow")}
      title={t("details.title")}
      icon={CalendarDays}
    >
      <div className="grid lg:grid-cols-12 gap-4">
        <Card className="lg:col-span-7 p-6 sm:p-8">
          <h3 className="font-serif text-2xl">{t("details.timeline_title")}</h3>
          <div className="mt-6 grid gap-4">
            {timeline.map((item) => (
              <TimelineItem
                key={`${item.time}-${item.title}`}
                time={item.time}
                title={item.title}
                desc={item.desc}
              />
            ))}
          </div>
        </Card>

        <Card className="lg:col-span-5 p-6 sm:p-8">
          <h3 className="font-serif text-2xl">{t("details.venue_title")}</h3>
          <p className="mt-3 text-sm text-theme-text-muted">
            {t("details.venue_text")}
          </p>

          <div className="mt-6 grid gap-3">
            <InfoPill icon={MapPin} label={t("details.location_pill")} />
            <InfoPill icon={CalendarDays} label={t("details.date_pill")} />
          </div>

          <button
            className="mt-6 w-full rounded-2xl border border-theme-border-subtle bg-theme-surface px-4 py-3 text-sm text-theme-text-muted hover:bg-theme-surface-hover transition"
            onClick={() =>
              window.open(t("details.map_url"), "_blank", "noopener,noreferrer")
            }
          >
            {t("details.open_map")}
          </button>
        </Card>
      </div>
    </Section>
  );
}
